import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Redirect, useLocation } from 'react-router-dom'
import { selectors as memberSelectors } from 'member-reducer'
import { PATH, makeMemberApplicationPath } from 'config'

const propTypes = {
  checkoutComplete: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  selectedMembershipType: PropTypes.string,
}

const INITIAL_MEMBER_APPLICATION_PATHS = [
  makeMemberApplicationPath(),
  makeMemberApplicationPath(PATH.ROOT),
  makeMemberApplicationPath(PATH.NEW_MEMBER_QUESTIONNAIRE),

  // Required to prevent redirect after successful membership application
  makeMemberApplicationPath(PATH.CONFIRM_AND_LOGIN),
]

function QuestionnaireRedirect({
  checkoutComplete,
  children,
  selectedMembershipType,
}) {
  const location = useLocation()

  // Push user back through member application root if no type has been
  // recommended / selected yet. Skip when checkout just completed (Routes
  // already redirects to /confirm-and-login) so we don't bounce through root.
  if (
    !selectedMembershipType &&
    !checkoutComplete &&
    !INITIAL_MEMBER_APPLICATION_PATHS.includes(location.pathname)
  ) {
    return <Redirect to={makeMemberApplicationPath(PATH.ROOT)} />
  }

  return children
}

QuestionnaireRedirect.propTypes = propTypes

function mapStateToProps(state) {
  return {
    checkoutComplete: memberSelectors.checkoutComplete(state),
    selectedMembershipType: memberSelectors.selectedMembershipType(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  QuestionnaireRedirect
)
